export default __webpack_public_path__ + "static/media/AS Jewellers.98d2cce9.jpg";